export enum WeightConversion {
  PoundToKg = 0.45359237,
  PoudnToGrams = 453.59237,
}
